"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";

// Shared behaviour for any full-screen overlay: Escape closes it, and the page
// underneath stops scrolling while it is up.
//
// The previous overflow value is captured and restored rather than reset to "",
// so an overlay opened on a page that was already locked (a nav drawer, say)
// does not silently unlock it on close.
export const useModalOverlay = (open, onClose) => {
  const $ = _c(4);
  let t0;
  let t1;
  if ($[0] !== onClose || $[1] !== open) {
    t0 = () => {
      if (!open) {
        return;
      }
      const onKey = e => {
        if (e.key === "Escape") {
          onClose();
        }
      };
      const previousOverflow = document.body.style.overflow;
      document.body.style.overflow = "hidden";
      window.addEventListener("keydown", onKey);
      return () => {
        document.body.style.overflow = previousOverflow;
        window.removeEventListener("keydown", onKey);
      };
    };
    t1 = [open, onClose];
    $[0] = onClose;
    $[1] = open;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
};